import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import PaperDraggable from "../../../../../components/PaperDraggable";
import { FormProvider, useForm } from "react-hook-form";
import { useMutation } from "react-query";
import axiosClient from "../../../../../lib/axios";
import { enqueueSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import { desformatarCPFCNPJ, desformatarTelefone } from "../../../../../helpers/unmask";
import FormIncluirCooperado from "./FormIncluirCooperado";
import { formatarMonetárioParaNúmero } from "../../../../../helpers/masks";
import { ISolicitarInclusaoCooperado } from "../../../../../types/mutations/cadastros/solicitar-inclusao-cooperado";

export default function DialogIncluirCooperado({
    open,
    handleClose,
}: DialogIncluirCooperadoProps) {

    const navigate = useNavigate();

    //Querys e mutations
    const { mutate: solicitarCriacao, isLoading: isLoadingSolicitacao } = useMutation({
        mutationKey: 'solicitar-inclusao-cooperado',
        mutationFn: (inputs: ISolicitarInclusaoCooperado) => axiosClient.post("/cadastros/solicitar-inclusao-cooperado", inputs),
        onError: (error) => {
            console.error(error)
            enqueueSnackbar('Erro ao solicitar inclusão de cooperado!', { variant: 'error' });
        },
        onSuccess: ({ data }) => {
            enqueueSnackbar(`Processo #${data} criado com sucesso!`, { variant: "success" });
            navigate(`/tarefas?detalhe-processo=${data}`);
            handleClose()
        }
    })

    //Funções manipuladoras
    const onSubmit = (data: IFormData) => {
        const params: ISolicitarInclusaoCooperado = {
            nome_publico: data.publico_nome,
            cpf_cnpj: desformatarCPFCNPJ(data.cpf_cnpj),
            email: data.email,
            telefone: desformatarTelefone(data.telefone),
            limite_desejado: formatarMonetárioParaNúmero(data.limite_desejado),
            justificativa: data.justificativa,
        }
        solicitarCriacao(params)
    }
    //

    const methods = useForm<IFormData>({ defaultValues: defaultValuesForm })


    return (
        <FormProvider {...methods}>
            <Dialog
                open={open}
                onClose={handleClose}
                PaperComponent={PaperDraggable}
                aria-labelledby="draggable-dialog-title"
                fullWidth
                maxWidth={"md"}
                scroll="body"
            >
                <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                    <Typography variant="h6">Solicitar inclusão de cooperado</Typography>
                </DialogTitle>

                <DialogContent>
                    <FormIncluirCooperado />
                </DialogContent>

                <DialogActions>
                    <Button
                        variant="text"
                        disabled={isLoadingSolicitacao}
                        onClick={handleClose}
                    >
                        Fechar
                    </Button>

                    <Button
                        variant="contained"
                        color="primary"
                        disabled={isLoadingSolicitacao}
                        onClick={methods.handleSubmit(onSubmit)}
                    >
                        {
                            isLoadingSolicitacao &&
                            <CircularProgress size={15} sx={{ marginRight: 1 }} />
                        }
                        Solicitar
                    </Button>
                </DialogActions>

            </Dialog>
        </FormProvider>
    )
}

const defaultValuesForm = {
    publico_nome: '',
    cpf_cnpj: '',
    email: '',
    telefone: '',
    limite_desejado: '',
    justificativa: '',
}

interface DialogIncluirCooperadoProps {
    open: boolean;
    handleClose: () => void;
}

interface IFormData {
    publico_nome: string;
    cpf_cnpj: string;
    email: string;
    telefone: string;
    limite_desejado: string;
    justificativa: string;
}








